const theme = {
  colors: {
    base: '#121212', // Black
    secondary: '#e9e9e9', // Medium Gray
    tertiary: '#f3f3f3', // Light Gray
    highlight: '#5b8bf7', // Light Blue
    titleBorder: '#1d3d87',
    imageBorder: '#979797',
    inputBG: '#dbdbdb',
    white: '#ffffff',
    black: '#000000',
    brownGrey: '#646464',
    lightPink: '#ededed',
    red: '#f70000',
    grey: '#f3f3f3',
    darkGrey: '#1d1d1d',
    lightGrey: '#b8b8b8',
    cobalt: '#1d3d87', // Dark Blue
    imageBackground: '#eeeeee', // Image background while it's lazyloaded
  },
  sizes: {
    maxWidth: '112rem',
    maxWidthCentered: '74rem',
    maxWidthTitle: '25rem',
    maxWidthTitleSmall: '12.5rem',
  },
  responsive: {
    small: '480px',
    medium: '820px',
    large: '1040px',
    xlarge: '1440px',
  },
  padding: {
    medium: '3.2rem',
  },
  fonts: {
    primary:
      '"Myriad Pro", "A+mfCv-AXIS Font ベーシック L ProN", "Helvetica Neue", YuGothic, "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", Arial, メイリオ, Meiryo, sans-serif',
    bold:
      '"Myriad Pro", "A+mfCv-AXIS Font ベーシック M ProN", "Helvetica Neue", YuGothic, "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", Arial, メイリオ, Meiryo, sans-serif',
  },
}

export default theme
